/**
 * @author 3173
 * @description 课程内容-添加课件
 * @Date 2020/2/13
 */
import React from "react";
import {connect} from "dva";
import {modelUtils} from "@/utils";
import {component_tool, framework_tool, utils_tool} from "@/tool";
import createColumns from "./examListColumns";

const {
  WizCard,
  WizSearchBar,
  WizDataTable,
  WizListSelect,
  WizRow,
  WizCol
} = component_tool;
const {WizContainer} = framework_tool;
const {getPageData} = utils_tool;

class ExamList extends WizContainer {
  componentName = "ExamList";

  constructor(props) {
    super(props);
    this.state = {
      defaultSearch: true,
      apiParams: {},
      visible: false,
      record: null
    };
  }

  static defaultProps = {
    selectedRows: []
  }

  propsAndStateOnChange = {
    examList: this._getListOver.bind(this),
  };

  _getListOver(nextProps, nextState) {
    let examList = [];

    return true;
  }

  _componentDidMount = () => {
    this._getData();
  };

  _getData(other = {}) {
    let existIds = []
    const {exists} = this.props;
    if (exists && exists.length > 0) {
      exists.forEach(element => {
        if (element && element.type != null && element.type === 1) {
          existIds.push(element.entityId)
        }
      });
    }
    this.doAction({
      path: "exam/getListByPage",
      payload: {
        key: "examList",
        apiParams: {type: 1, status: 1, ...other,...this.state.apiParams, existIds: existIds}//categoryType应该为 课程考试 , 非课程内容引用请自己传类型进来 ,categoryType:this.props.categoryType? this.props.categoryType:'课程考试'
      } //20200518 考试列表接口参数修改，分类类型为categoryTypeIds 10为课程考试类型id  be_update_by_wuTao 20201213 添加查询type=1的考试 为 课程考试
    });
  }

  /**是否不可选，已被选择并展示再页面中的部分将不可选 */
  isNeedDisabled(id) {
    const {exists} = this.props;
    if (exists && exists.length > 0) {
      for (let i = 0; i < exists.length; i++) {
        if (exists[i].entityId === id && exists[i].type == 1) {
          return true;
        }
      }
    }
    return false;
  }

  onRow(record) {
    return {
      onClick: event => {
        log.info(event);
      }, // 点击行
      onDoubleClick: event => {
      },
      onContextMenu: event => {
      },
      onMouseEnter: event => {
      }, // 鼠标移入行
      onMouseLeave: event => {
      },
    };
  }

  _render() {
    const {examList, examLoading, selectedRows, updateRows, handleClear} = this.props;
    const {record, visible} = this.state;
    const dataItems = getPageData(examList.data);
    const other = {};
    const columns = createColumns(this, dataItems, other);
    const searchBarProps = {
      columns,
      collapse: false,
      onSearch: values =>
        this.setState({apiParams: values}, () => {
          this._getData();
        })
    };

    const dataTableProps = {
      loading: examLoading,
      columns,
      rowKey: "id",
      dataItems,
      selectType: "checkbox",
      showNum: false,
      isScroll: true,
      onChange: ({pageNum, pageSize}) => {
        this._getData({current: pageNum, size: pageSize});
      },
      selectedRowKeys: selectedRows.map(item => item.rowKey),
      onSelect: (keys, rows) => {
        this.keys = keys;
        updateRows(rows)
      },
      rowSelection: {
        getCheckboxProps: record => ({
          disabled: this.isNeedDisabled(record.id),
        }),
      },
      // onRow:this.onRow.bind(this)
    };

    const listSelectProps = {
      type: '考试',
      rows: selectedRows,
      handerClear: (id) => {
        handleClear(id)
      }
    }

    return (
      <WizRow>
        <WizCol span={16}>
          <WizCard bodyStyle={{padding: '0 15px'}}>
            <WizSearchBar
              type="grid"
              {...searchBarProps}
              cols={{xs: 14, md: 12, xl: 10}}
            />
            <WizDataTable style={{marginTop: 15}} {...dataTableProps} />
            <div className="pagination">
              <WizDataTable.Pagination {...dataTableProps} />
            </div>
          </WizCard>
        </WizCol>
        <WizCol span={8}>
          <WizListSelect {...listSelectProps} />
        </WizCol>
      </WizRow>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {exam} = state;
  const examList = modelUtils.getModelEntity(exam, "examList");

  const load = modelUtils.getLoadingState(state, "exam");
  return {
    examList: examList,
    ...load
  };
};


export default connect(mapStateToProps)(ExamList);
